export enum UAT_USAGE_OPTIONS {
  SGFINDEX_VANILLA_TABLES = 'SGFINDEX_VANILLA_TABLES',
  MOCK_SINGPASS = 'MOCK_SINGPASS',
  ACTUAL_SINGPASS = 'ACTUAL_SINGPASS',
}
